export default __webpack_public_path__ + "3ae6ae45b4daec79ca380ca36117e63f.svg";